<div class="card">
  <div class="ui-g ui-fluid">
    <div class="ui-g-12" style="padding-left: 11px;">
      <button
        pButton
        type="button"
        class="k-generic-btn"
        icon="fa fa-angle-left"
        iconPos="left"
        label="{{ 'common.back' | translate }}"
        (click)="goBack()">
      </button>
    </div>
    <div class="ui-g-12">
      <sf-form [schema]="mySchema" [(model)]="myModel"></sf-form>
      <div style="padding-left: 11px;">
        <button
          pButton
          type="button"
          class="k-generic-btn"
          label="{{ 'common.save' | translate }}"
          (click)="submitForm()"
          [disabled]="readonly">
        </button>
        <button
          pButton
          type="button"
          class="k-generic-btn"
          label="{{ 'common.cancel' | translate }}"
          (click)="goBack()"
          [disabled]="readonly">
        </button>
      </div>
    </div>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/json-schema-form.component.html